/* eslint-disable react/jsx-props-no-spreading */

import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";

const TextArea = ({
  error,
  label,
  register,
  required,
  name,
  placeholder,
  _css,
  ...rest
}) => {
  const title = name.replace(/([a-z])([A-Z])/g, `$1 $2`);
  let errorMessage;
  if (error?.type === `required`) {
    errorMessage = (
      <p
        className="b2"
        css={css`
          color: var(--color-raspberry-dark);
          margin-bottom: 0.75rem;
        `}
      >
        <span
          css={css`
            text-transform: capitalize;
          `}
        >
          {title}
        </span>
        {` `}
        is required
      </p>
    );
  }

  if (label) {
    return (
      <label htmlFor={name}>
        <span>{label}</span>
        <textarea
          placeholder={placeholder}
          {...register(name, { required })}
          {...rest}
          css={css`
            ${_css} ${error?.type && `border: 1px solid red;`}
          `}
        />
        {errorMessage && errorMessage}
      </label>
    );
  }

  return (
    <>
      <textarea
        placeholder={placeholder}
        {...register(name, { required })}
        {...rest}
        css={css`
          ${_css} ${error?.type && `border: 1px solid red;`}
        `}
      />
      {errorMessage && errorMessage}
    </>
  );
};

export default TextArea;

TextArea.propTypes = {
  error: PropTypes.shape({
    type: PropTypes.string
  }),
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  register: PropTypes.func,
  required: PropTypes.bool,
  _css: PropTypes.shape({})
};

TextArea.defaultProps = {
  error: {
    type: ``
  },
  label: ``,
  placeholder: ``,
  register: () => {},
  required: false,
  _css: []
};
